import { Box, Group, SegmentedControl } from '@mantine/core';
import { IconHistory, IconMessageCircle, IconSparkles } from '@tabler/icons-react';
import classes from './ChatModeTabs.module.css';

export type ChatBarTab = 'action' | 'chat' | 'history';

export const CHAT_BAR_TAB_LABELS: Record<ChatBarTab, string> = {
  action: 'Actions',
  chat: 'Conversation',
  history: 'History',
};

const TABS = [
  { value: 'action' as const, label: CHAT_BAR_TAB_LABELS.action, Icon: IconSparkles },
  { value: 'chat' as const, label: CHAT_BAR_TAB_LABELS.chat, Icon: IconMessageCircle },
  { value: 'history' as const, label: CHAT_BAR_TAB_LABELS.history, Icon: IconHistory },
];

type ChatModeTabsProps = {
  value: ChatBarTab;
  onChange: (value: ChatBarTab) => void;
  historyHasActivity?: boolean;
  conversationHasActivity?: boolean;
};

export function ChatModeTabs({
  value,
  onChange,
  historyHasActivity,
  conversationHasActivity,
}: ChatModeTabsProps) {
  const showDot: Record<ChatBarTab, boolean> = {
    action: false,
    chat: Boolean(conversationHasActivity),
    history: Boolean(historyHasActivity),
  };

  return (
    <SegmentedControl
      fullWidth
      value={value}
      onChange={next => onChange(next as ChatBarTab)}
      color="brand"
      withItemsBorders={false}
      classNames={{ label: classes.label }}
      styles={{
        root: { padding: 3, borderRadius: 20, backgroundColor: 'rgba(0, 0, 0, 0.2)' },
        indicator: { borderRadius: 16 },
        label: { borderRadius: 16, paddingTop: 10, paddingBottom: 10 },
      }}
      data={TABS.map(({ value: tabValue, label, Icon }) => ({
        value: tabValue,
        label: (
          <Group gap={6} justify="center" wrap="nowrap">
            <Icon size={16} />
            <span>{label}</span>
            {showDot[tabValue] && (
              <Box w={8} h={8} bg="orange.6" style={{ borderRadius: '50%' }} aria-label="Unread" />
            )}
          </Group>
        ),
      }))}
    />
  );
}
